import { types } from "../types/types";

const initialState = {
    datosCartilla: null,
    miCartilla: null,
    loading: false
};

export const cartillaMiOspedycReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.cartillaMiOspedycTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.cartillaMiOspedycTraerSuccess:
            return {
                ...state,
                datosCartilla: action.payload,
                loading: false
            }
        case types.cartillaMiOspedycTraerError:
            return {
                ...state,
                datosCartilla: [],
                loading: false
            }
        case types.miCartillaMiOspedycTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.miCartillaMiOspedycTraerSuccess:
            return {
                ...state,
                miCartilla: action.payload,
                loading: false
            }
        case types.miCartillaMiOspedycTraerError:
            return {
                ...state,
                miCartilla: [],
                loading: false
            }
        default:
            return state;
    }
};
